import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
const mixin = {
  mixins: [validationMixin],
  validations: {
    name: { required },
  },
  computed: {
    nameErrors() {
      const errors = [];
      if (!this.$v.name.$dirty) return errors;
      !this.$v.name.required && errors.push("チャッター名を入力してください。");
      return errors;
    },
  },
};

export default mixin;
